// extracted by mini-css-extract-plugin
module.exports = {"loading":"Spinner_loading__L_ANh"};